import { createFileRoute } from '@tanstack/react-router'
import LazyRoute from '@/components/LazyRoute'

export const Route = createFileRoute('/_protected/organization/settings/')({
  component: () => (
    <LazyRoute
      loader={() => import('@/components/organization-settings/general')}
      fallback={<div>Loading...</div>}
    />
  ),
})